module.exports = __webpack_public_path__ + "static/media/41-11.74ef713f.mp3";